/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section4_P1Inputs */

const en_privacy_section4_p1 = /** @type {(inputs: Privacy_Section4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON uses Google AdSense to display advertisements. Google may use cookies to serve ads based on your prior visits to this or other websites. You can opt out of personalized advertising by visiting Google's Ads Settings.`)
};

const ko_privacy_section4_p1 = /** @type {(inputs: Privacy_Section4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 광고 표시를 위해 Google AdSense를 사용합니다. Google은 이전 방문 기록을 기반으로 쿠키를 사용하여 광고를 제공할 수 있습니다. Google 광고 설정에서 맞춤 광고를 해제할 수 있습니다.`)
};

const ja_privacy_section4_p1 = /** @type {(inputs: Privacy_Section4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONは広告表示にGoogle AdSenseを使用しています。Googleは過去の訪問履歴に基づいてCookieを使用して広告を配信する場合があります。Googleの広告設定からパーソナライズド広告をオプトアウトできます。`)
};

/**
* | output |
* | --- |
* | "PureJSON uses Google AdSense to display advertisements. Google may use cookies to serve ads based on your prior visits to this or other websites. You can opt..." |
*
* @param {Privacy_Section4_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section4_p1 = /** @type {((inputs?: Privacy_Section4_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section4_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section4_p1(inputs)
	if (locale === "ko") return ko_privacy_section4_p1(inputs)
	return ja_privacy_section4_p1(inputs)
});